import { registerTechnique } from './registry';

// ── Feld & Partikel ─────────────────────────────────────────────────────────
import { flowField } from './flowField/definition';
import { glyphParticles } from './glyphParticles/definition';
import { boids } from './boids/definition';
import { forceField } from './forceField/definition';

// ── Organisches Wachstum ────────────────────────────────────────────────────
import { lsystemTree } from './lsystemTree/definition';
import { roots } from './roots/definition';
import { dla } from './dla/definition';
import { physarum } from './physarum/definition';
import { spaceColonization } from './spaceColonization/definition';
import { moss } from './moss/definition';

// ── Packung ─────────────────────────────────────────────────────────────────
import { circlePacking } from './circlePacking/definition';
import { poissonScatter } from './poissonScatter/definition';
import { voronoi } from './voronoi/definition';
import { delaunay } from './delaunay/definition';
import { rectPacking } from './rectPacking/definition';

// ── Rauschverzerrung ────────────────────────────────────────────────────────
import { domainWarp } from './domainWarp/definition';
import { displacement } from './displacement/definition';
import { glitch } from './glitch/definition';
import { contourLines } from './contourLines/definition';

// ── Automaten ───────────────────────────────────────────────────────────────
import { reactionDiffusion } from './reactionDiffusion/definition';
import { gameOfLife } from './gameOfLife/definition';
import { erosion } from './erosion/definition';

// ── Physik ──────────────────────────────────────────────────────────────────
import { softBody } from './softBody/definition';
import { fluid } from './fluid/definition';
import { shatter } from './shatter/definition';
import { rope } from './rope/definition';

// ── Dekonstruktion ──────────────────────────────────────────────────────────
import { asciiMosaic } from './asciiMosaic/definition';
import { halftone } from './halftone/definition';
import { fragmentation } from './fragmentation/definition';
import { textFromText } from './textFromText/definition';
import { skeleton } from './skeleton/definition';
import { hatching } from './hatching/definition';

// ── Dimension ───────────────────────────────────────────────────────────────
import { extrude3d } from './extrude3d/definition';
import { heightField } from './heightField/definition';
import { pointCloud3d } from './pointCloud3d/definition';

/**
 * Single registration point.
 *
 * Adding a technique means adding one import and one call here — nothing else in the
 * app needs to change, because the UI, the randomiser and the batch engine all read
 * the technique's own parameter schema.
 *
 * The order below is the order they appear in the layer picker, grouped by category,
 * and follows the order the categories are defined in `types.ts`.
 */
let registered = false;

export function registerAllTechniques(): void {
  if (registered) return;
  registered = true;

  registerTechnique(flowField);
  registerTechnique(glyphParticles);
  registerTechnique(boids);
  registerTechnique(forceField);

  registerTechnique(lsystemTree);
  registerTechnique(roots);
  registerTechnique(dla);
  registerTechnique(physarum);
  registerTechnique(spaceColonization);
  registerTechnique(moss);

  registerTechnique(circlePacking);
  registerTechnique(poissonScatter);
  registerTechnique(voronoi);
  registerTechnique(delaunay);
  registerTechnique(rectPacking);

  registerTechnique(domainWarp);
  registerTechnique(displacement);
  registerTechnique(glitch);
  registerTechnique(contourLines);

  registerTechnique(reactionDiffusion);
  registerTechnique(gameOfLife);
  registerTechnique(erosion);

  registerTechnique(softBody);
  registerTechnique(fluid);
  registerTechnique(shatter);
  registerTechnique(rope);

  registerTechnique(asciiMosaic);
  registerTechnique(halftone);
  registerTechnique(fragmentation);
  registerTechnique(textFromText);
  registerTechnique(skeleton);
  registerTechnique(hatching);

  registerTechnique(extrude3d);
  registerTechnique(heightField);
  registerTechnique(pointCloud3d);
}

registerAllTechniques();
